export default [
  {
    path: '/exportar-dados',
    component: () => import('@/pages/ExportarDados/Template.vue'),
    children: [
      {
        path: '/exportar-dados',
        component: () => import('@/pages/ExportarDados/Index.vue'),
      },
    ],
  },
]
